module.exports = __webpack_public_path__ + "static/img/logo.9bdda0b6.png";